<template>
  <div class="broadcast-notification">
    <NotificationLayout>
      <template #icon>
        <div class="icon">
          <img class="icon__img" src="@/assets/notification-icons/broadcast.svg" aria-hidden="true" />
        </div>
      </template>

      <template #content>
        <div class="notification-header">
          {{ title }}
        </div>
        <div class="notification-body">
          {{ message }}
        </div>
        <div
          @click="removeBroadcast"
          role="button"
          aria-label="Remove broadcast"
          v-if="canRemoveBroadcast"
          class="broadcast-remove"
        >
          <img src="@/assets/global-icons/cross-red.svg" aria-hidden="true" />
          <span>Remove</span>
        </div>
      </template>
    </NotificationLayout>
  </div>
</template>
<script>
// Wrapper for a sidebar notification.
import { mapGetters, mapActions } from 'vuex';
import NotificationLayout from './parts/NotificationLayout.vue';

export default {
  name: 'Broadcast',
  props: {
    data: Object
  },
  components: {
    NotificationLayout
  },
  computed: {
    ...mapGetters({
      getNotificationMeta: 'getNotificationMeta',
      userType: 'current_user/currentAreaPermissionNo'
    }),
    meta() {
      return this.getNotificationMeta(this.data);
    },
    title() {
      return this.data.title;
    },
    message() {
      return this.data.message;
    },
    canRemoveBroadcast() {
      return this.userType > 0;
    }
  },
  methods: {
    ...mapActions(['deleteBroadcast', 'popups/notifications/confirmDeleteBroadcast']),
    removeBroadcast() {
      const callback = () => this.deleteBroadcast(this.data.id)
      this['popups/notifications/confirmDeleteBroadcast']({ callback })
    }
  }
};
</script>
<style scoped lang="scss">
@import '~@/scss/components/notifications/notification_styles.scss';

.broadcast-remove {
  text-align: right;
  color: $red;
  font-size: 0.75rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;

  img {
    width: 8px;
    height: 8px;
    margin-right: 5px;
    margin-top: 1px;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.icon {
  box-sizing: border-box;
  width: 45px;
  height: 45px;
  border: 2px solid $grey-4;

  border-radius: 100%;
  background-color: $grey-7;

  display: flex;
  justify-content: center;
  align-items: center;

  &__img {
    width: 25px;
    height: 25px;
    filter: brightness(0) saturate(100%) invert(46%) sepia(98%) saturate(385%) hue-rotate(156deg) brightness(93%)
      contrast(88%);
    position: relative;
    left: -1px;
  }
}
</style>
